import { VueModule } from '@Foundation';
import Accordions from './code/Scripts/components/accordions';

export default VueModule({
  components: {
    Accordions
  }
});
